define('apps/course-intro/views/regions/levels/level-grid',[
    'apps/course-intro/views/items/level'
], function (LevelView) {
    "use strict";

    return Mn.CollectionView.extend({

        "childView": LevelView,

        "childViewOptions": function (model) {
            return {
                "levelNum": this.collection.indexOf(model)
            };
        },

        "onShow": function () {
            $(document).on('keydown', null, {"levelView": this}, this.unlockLevelKeydown);
        },

        "unlockLevelKeydown": function (event) {
            var character = String.fromCharCode(event.which),
                currentView = event.data.levelView;

            if (event.ctrlKey && event.shiftKey && character.toLowerCase() === 'u') {
                currentView.unlockAllLevels();
            }
        },

        "unlockAllLevels": function () {
            this.collection.each(function (level) {
                if (!level.get('isUnlocked')) {
                    level.set('isUnlocked', true);
                }
            });
        },

        "onDestroy": function () {
            $(document).off('keydown', this.unlockLevelKeydown);
        }
    });
});


